import Bold from './check.bold.svg?react'
import Duotone from './check.duotone.svg?react'
import Fill from './check.fill.svg?react'
import Regular from './check.regular.svg?react'
import { createIcon } from './factory'

export const Check = createIcon({ regular: Regular, bold: Bold, fill: Fill, duotone: Duotone })
